import { FundClassification } from '@/models/common/FundClassification';
import CoordinatorsSection from '../components/CoordinatorsSection';
import styles from './steps.module.scss';

interface ApplicantAndCoordinatorsStepProps {
  classification: FundClassification.Welfare | FundClassification.Community;
}

const ApplicantAndCoordinatorsStep = ({
  classification,
}: ApplicantAndCoordinatorsStepProps) => {
  return (
    <div className={styles.stepWrapper}>
      <CoordinatorsSection classification={classification} />
    </div>
  );
};

export default ApplicantAndCoordinatorsStep;
